import { formatMoney } from "Helpers/helpFunction"

export default function NumberTrading2({ data }: { data: any }) {
  const eps = data?.eps ? formatMoney((parseFloat(data?.eps) / 1000).toFixed(2), 2) : '--'
  const pe = data?.pe ? formatMoney(data?.pe, 2) : '--'
  const pb = data?.pb ? formatMoney(data?.pb, 2) : '--'
  const bookValue = data?.bookValue ? formatMoney((parseFloat(data?.bookValue) / 1000).toFixed(2), 2) : '--'

  return (
    <>
      <div className='LnlQJDZgDw'>
        <div className='sRqFgiPXSm'>
          <div className='MelmxNfyJN'>EPS <span className="lgiztqblvc">(Nghìn đồng)</span></div>
          <div className='feUQoYfHgV RiIjUzmqZf'>{eps}</div>
        </div>
        <div className='sRqFgiPXSm'>
          <div className='MelmxNfyJN'>Book value <span className="lgiztqblvc">(Nghìn đồng)</span></div>
          <div className='feUQoYfHgV RiIjUzmqZf'>{bookValue}</div>
        </div>
        <div className='sRqFgiPXSm'>
          <div className='MelmxNfyJN'>P/E</div>
          <div className='feUQoYfHgV RiIjUzmqZf'>{pe}</div>
        </div>
        <div className='sRqFgiPXSm'>
          <div className='MelmxNfyJN'>P/B</div>
          <div className='feUQoYfHgV RiIjUzmqZf'>{pb}</div>
        </div>
        {/* <div className='sRqFgiPXSm'>
          <div className='MelmxNfyJN'>Tăng trưởng EPS 3 năm</div>
          <div className='feUQoYfHgV RiIjUzmqZf'>15%</div>
        </div> */}
      </div>
    </>
  )
}